app.commonController = app.commonController || {};
app.commonController.defaultAction = {

    /**
     * Initialisation de la fonction
     * @returns {undefined}
     */
    init : function () {
        this.touch();
        this.switchButton();
        this.menuMobile();
        this.cookiesConsent();
        this.scrollToTop();
    },

    touch : function () {
        // Touch detection
        if (!('ontouchstart' in document.documentElement)) {
            $('html').removeClass('touch').addClass('no-touch');
        }
        else {
            $('html').removeClass('no-touch').addClass('touch');
        }

        // Enable transition after DOM is loaded
        $("body").removeClass("preload");
    },

    switchButton : function () {
        var toggle = $('.header-content .toggle');
        var toggleText = $('.header-content .toggle-text');
        var toggleFirst = $('.header-content .toggle-first');
        var toggleSecond = $('.header-content .toggle-second');

        toggleText.on('click', function() {
            var form = $('#form-univers');
            var input = $('#input-univer', form);

            if ($(this).hasClass('toggle-first')) {
                toggle.addClass('left');
                toggle.removeClass('right');

                toggleFirst.addClass('active');
                toggleSecond.removeClass('active');

                input.val('particulier');
            } else {
                toggle.addClass('right');
                toggle.removeClass('left');

                toggleSecond.addClass('active');
                toggleFirst.removeClass('active');

                input.val('entreprise');
            }

            form.submit();
        });
    },

    menuMobile : function () {
        var btnMenu = $('.hamburger');
        var menu = $('.header-content .blk-right');
        var btnContact = $('#nous-contacter');

        btnMenu.on('click', function () {
            $(this).toggleClass('is-active');
            menu.toggleClass('is-active');
            btnContact.toggleClass('is-active');
        });

        var links = $('#menu-header-bottom-particulier li.menu-item-has-children > span, #menu-header-bottom-particulier li.menu-item-has-children > a, #menu-header-bottom-entreprise li.menu-item-has-children > span, #menu-header-bottom-entreprise li.menu-item-has-children > a');

        links.on('click', function (e) {
            if (window.matchMedia("(max-width: 1024px)").matches) {
                e.preventDefault();

                if ($(this).closest('li').hasClass('active')) {
                    $(this).closest('li').removeClass('active');
                } else {
                    links.closest('li').removeClass('active');
                    $(this).closest('li').addClass('active');
                }

            }
        });
    },

    waitForElementToDisplay : function (selector, callback, checkFrequencyInMs, timeoutInMs) {
        var startTimeInMs = Date.now();
        (function loopSearch() {
            if (document.querySelector(selector) != null) {
                callback();
            }
            else {
                setTimeout(function () {
                    if (timeoutInMs && Date.now() - startTimeInMs > timeoutInMs)
                        return;
                    loopSearch();
                }, checkFrequencyInMs);
            }
        })();
    },

    cookiesConsent : function () {
        var footerContent = document.createElement("div");
        footerContent.classList.add('cookies-consent-footer');
        footerContent.innerHTML = "Les cookies de fonctionnalités proposées sur le site ne nécessitent pas votre consentement préalable. Vous pouvez, toutefois, vous y opposer en cliquant sur « Gérer mes préférences ». Retrouvez, à tout moment, votre paramétrage en bas de page, à côté de notre politique de protection des données.";

        this.waitForElementToDisplay("#tarteaucitronAlertBig",function(){
            var AcceptAllBtn = document.getElementById('tarteaucitronPersonalize2');
            var content = document.querySelector('#tarteaucitronAlertBig');

            if (AcceptAllBtn) {
                content.appendChild(AcceptAllBtn);
            }

            content.appendChild(footerContent);
        },1000,9000);

    },

    scrollToTop : function () {
        $('.scrollToTop').click(function (e) {
            e.preventDefault();
            $('html, body').animate({
                scrollTop: 0
            }, 'slow');
            return false;
        });
    }
};

$(document).ready(function(){
    app.commonController.defaultAction.init();
});
